import StandardError from '../../StandardError'

export default class AlreadyInCartError extends StandardError {
  constructor(error) {
    super('errors.cart.already_in_cart')
    this.cartItem = error.cartItem
  }
}
